var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.267,
    height: 21.511,
    viewBox: "0 0 32.267 21.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c8564a63273a2e5182f858b8ed02aa107{fill: currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c8564a63273a2e5182f858b8ed02aa107",
    d: "M28.1,14.067V7.793A1.8,1.8,0,0,0,26.3,6H4.793A1.8,1.8,0,0,0,3,7.793V25.719a1.8,1.8,0,0,0,1.793,1.793H26.3A1.8,1.8,0,0,0,28.1,25.719V19.444L32.2,23.549a1.8,1.8,0,0,0,3.065-1.273V11.216A1.8,1.8,0,0,0,32.2,9.944Zm-7.171,4.481H17.341v3.585a1.793,1.793,0,0,1-3.585,0V18.548H10.171a1.793,1.793,0,1,1,0-3.585h3.585V11.378a1.793,1.793,0,0,1,3.585,0v3.585h3.585a1.793,1.793,0,1,1,0,3.585Z",
    transform: "translate(-3 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/video-upload.b4bcc247.svg";
export { ForwardRef as ReactComponent };